<script>

  export default {
    data() {
      return {
        hasEmail: 0,
        hasSaleRep: 0,
        hasPrimaryContact: 0,
        boundCollapse: true,
      }
    },
    computed:{
      count(){
        return this.hasEmail + this.hasSaleRep + this.hasPrimaryContact
      }
    },
    watch: {
      hasEmail (val) {
        let parser = 1
        val ? parser = 1 : parser = 0
        this.$emit('filter', {
          has_email: parser,
        })
      },
      hasSaleRep (val) {
        let parser = 1
        val ? parser = 1 : parser = 0
        this.$emit('filter', {
          has_sales_rep: parser,
        })
      },
      hasPrimaryContact (val) {
        let parser = 1
        val ? parser = 1 : parser = 0
        this.$emit('filter', {
          has_primary_contact: parser,
        })
      },
    },
  }
</script>

<template>
  <div v-bind="$attrs" class="block-item">
    <div class="block-heading">
      <h3
        v-fabric-collapse.accordion-customer-data
        class="
          tw-flex tw-items-center
          tw-text-positive
          tw-leading-relaxed tw-font-medium tw-text-base">
        <a class="tw-no-underline" href="javascript:">Filter by data</a>
        <BaseChevronRotate
          transition-class="rotate-360-270"
          :toggle="!boundCollapse"
          :duration="500"
        />
      </h3>
      <FabricBadge
        :styling-bg="count ? 'badge-primary' : 'badge-light'"
        :copy="count"
      />
    </div>
    <FabricCollapse
      id="accordion-customer-data"
      v-model="boundCollapse"
      hide-header
      :duration="500"
      :default-shown="boundCollapse">
      <div class="block-content">
        <FabricCheckbox
          v-model="hasEmail"
          slot-classes="tw-pl-3 tw-text-black"
        >Has email</FabricCheckbox>
        <FabricCheckbox
          v-model="hasSaleRep"
          slot-classes="tw-pl-3 tw-text-black"
        >Has sale rep</FabricCheckbox>
        <FabricCheckbox
          v-model="hasPrimaryContact"
          slot-classes="tw-pl-3 tw-text-black"
        >Has primary contact</FabricCheckbox>
      </div>
    </FabricCollapse>
  </div>
</template>
